import TripUclTerms from './trip-ucl-terms-component';

import './trip-ucl-terms.scss';

const MODULE_NAME = 'app.trip.ucl-terms';
const module = angular.module(MODULE_NAME, [])
    .directive(TripUclTerms.DIRECTIVE_NAME, TripUclTerms);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-ucl-terms/trip-ucl-terms-module.js